
import React from 'react';
import { ShieldCheck, Server, Lock, Database } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Reveal } from '../Reveal';

export const DatenschutzPage: React.FC = () => {
    const { t } = useTranslation();

    return (
        <div className="pt-32 pb-20 bg-gray-50 min-h-screen">
            <div className="max-w-4xl mx-auto px-6">

                <Reveal>
                    <div className="flex items-center gap-4 mb-8 text-clever-teal">
                        <ShieldCheck size={40} />
                        <span className="font-bold uppercase tracking-widest text-sm">
                            {t('shared.legal.privacy.tagline')}
                        </span>
                    </div>
                    <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-12 tracking-tight">
                        {t('shared.legal.privacy.title')}
                    </h1>
                </Reveal>

                <Reveal delay={0.1}>
                    <div className="bg-white border border-gray-200 p-8 md:p-12 shadow-sm space-y-12 text-gray-600 leading-relaxed">

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                {t('shared.legal.privacy.sections.overview.title')}
                            </h2>
                            <p className="mb-4">
                                {t('shared.legal.privacy.sections.overview.text')}
                            </p>
                            <h3 className="font-bold text-gray-900 mt-6 mb-2">
                                {t('shared.legal.privacy.sections.overview.responsible')}
                            </h3>
                            <p>
                                CleverDigital GmbH<br />
                                Wiedner Gürtel 13<br />
                                1100 Wien, Österreich<br />
                                E-Mail: office@cleverdigital.at
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                                <Server size={24} className="text-clever-teal" />
                                {t('shared.legal.privacy.sections.hosting.title')}
                            </h2>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-2">
                                        {t('shared.legal.privacy.sections.hosting.vercel.title')}
                                    </h3>
                                    <p>
                                        {t('shared.legal.privacy.sections.hosting.vercel.text')}
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                                <Database size={24} className="text-clever-teal" />
                                {t('shared.legal.privacy.sections.backend.title')}
                            </h2>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-2">
                                        {t('shared.legal.privacy.sections.backend.supabase.title')}
                                    </h3>
                                    <p>
                                        {t('shared.legal.privacy.sections.backend.supabase.text')}
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-3">
                                <Lock size={24} className="text-clever-teal" />
                                {t('shared.legal.privacy.sections.ai.title')}
                            </h2>
                            <div className="space-y-6">
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-2">
                                        {t('shared.legal.privacy.sections.ai.form.title')}
                                    </h3>
                                    <p>
                                        {t('shared.legal.privacy.sections.ai.form.text')}
                                    </p>
                                </div>
                                <div>
                                    <h3 className="font-bold text-gray-900 mb-2">
                                        {t('shared.legal.privacy.sections.ai.gemini.title')}
                                    </h3>
                                    <p>
                                        {t('shared.legal.privacy.sections.ai.gemini.text')}
                                    </p>
                                </div>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                {t('shared.legal.privacy.sections.rights.title')}
                            </h2>
                            <p>
                                {t('shared.legal.privacy.sections.rights.text')}
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-gray-900 mb-4">
                                {t('shared.legal.privacy.sections.ssl.title')}
                            </h2>
                            <p>
                                {t('shared.legal.privacy.sections.ssl.text')}
                            </p>
                        </section>

                    </div>
                </Reveal>
            </div>
        </div>
    );
};
